import styled from '@emotion/styled';
import { LocationType } from 'domains/models/event_type/locationType';
import Image from 'presentations/views/components/atoms/Image';
import { fontSize, spacing } from 'presentations/views/styles';

type Props = {
  locationType: LocationType;
  name: string;
};

export default function Component(props: Props) {
  return (
    <StyledContainer>
      <StyledImage
        src={`locations/${props.locationType}.svg`}
        alt={props.name}
      />
      <StyledContent>
        <StyledName>{props.name}</StyledName>
      </StyledContent>
    </StyledContainer>
  );
}

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`;
const StyledImage = styled(Image)`
  max-width: 24px;
  max-height: 24px;
`;
const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${spacing(8)};
`;
const StyledName = styled.div`
  font-size: ${fontSize(14)};
`;
